import {React, Component, Container, _} from 'utils';
import {FairStore, Creators, StandStore, App} from 'model';
import {Back, ActiveStands, StandSearch, Loading} from 'components';
import './activitypage.less';

class IndexPage extends Component {

	static getStores()
	{
		return [FairStore, StandStore];
	}

	static calculateState()
	{
		let stands = StandStore.getActiveStands();
		let background = StandStore.getBackground();
		let title = FairStore.getFairTitle(_('Exhibitors'));
		let loading = StandStore.isLoading();

		return {
			stands,
			title,
			background,
			loading,
		}
	}

	componentDidMount()
	{
		Creators.loadStands();
	}

	render()
	{
		let {title, stands, background, loading} = this.state;

		App.setPageTitle(title);

		let style = {};

		if (background)
		{
			style.backgroundImage = App.url(background)
		}

		return (
			<div className="page index activity">
				<div className="menu">
					<nav className="navbar navbar-expand-lg navbar-light bg-light">
						<Back/>
					</nav>
				</div>
				<div className="container">
					<div className="background">
						<div style={style}/>
					</div>
					<div className="content">
						<div className="col-md-12">
							<h1 className="display-5">{_('Exhibitors')}</h1>
							<StandSearch/>
							<Loading visible={loading} description={_('Loading')}/>
							<ActiveStands data={stands}/>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default Container.create(IndexPage);


// WEBPACK FOOTER //
// ./src/modules/pages/indexpage.js